// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import { waitingAreaInitialState } from 'store/initialState';
import { clone } from './helper';
import {
  GET_WAITING_AREAS,
  GOT_WAITING_AREAS,
  UPDATE_WAITING_AREAS,
  GET_ORGANISATION_WAITING_AREAS,
  GOT_ORGANISATION_WAITING_AREAS,
  SELECT_WAITING_AREA,
  SELECT_WAITING_AREA_ENTITY,
  GOT_WAITING_AREA,
  GOT_WAITING_AREA_GC,
  UPDATE_FETCHING_WAITING_AREA,
  GOT_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS,
  GET_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS,
  UPDATE_WAITING_AREAS_PERMISSION,
  UPDATED_WAITING_AREA,
  RESET_WAITING_AREA,
  RESET_WAITING_AREA_FORM,
  UPDATED_CURRENT_FILLED_WAITING_AREA_STEP,
  UPDATED_CURRENT_CREATE_WAITING_AREA_STEP,
  UPDATED_WAITING_AREA_FORM,
  UPDATE_WAITING_AREAS_SEARCH,
  UPDATE_WAITING_AREA_SEARCH,
  UPDATE_WAITING_AREA_MEMBER_SEARCH,
  SUSPEND_ACCESS_WAITING_AREA,
  RESTORE_ACCESS_WAITING_AREA,
  GET_WAITING_AREA_WEBSITE_DETAILS,
  GOT_WAITING_AREA_WEBSITE_DETAILS,
  UPDATED_WEBSITE_BUTTON_FORM,
  UPDATE_WEBSITE_BUTTON_DETAILS,
  UPDATED_WEBSITE_BUTTON_DETAILS,
  CALLER_DISCONNECTED,
  ADD_TO_CALL_WAITING_AREA_PARTICIPANT,
  ADDED_TO_CALL_WAITING_AREA_PARTICIPANT,
  FAILED_ADDING_TO_CALL_WAITING_AREA_PARTICIPANT,
  UPDATED_VIDEO_SETTINGS_FOR_PROVIDER,
  UPDATE_VIDEO_SETTINGS_FOR_PROVIDER,
  UPDATE_MICROPHONE_SETTINGS_FOR_PROVIDER,
  UPDATED_MICROPHONE_SETTINGS_FOR_PROVIDER,
  RESET_WAITING_AREA_SMS_NOTIFICATION_FORM,
  UPDATE_WAITING_AREA_SMS_NOTIFICATION_FORM,
  UPDATE_WAITING_AREA_SMS_NOTIFICATION,
  UPDATED_WAITING_AREA_SMS_NOTIFICATION,
  ERROR_UPDATING_WAITING_AREA_SMS_NOTIFICATION,
  UPDATED_SHOW_SUSPEND_WA_MODAL,
  GET_WAITING_AREA_OPERATING_HOURS,
  GOT_WAITING_AREA_OPERATING_HOURS,
  UPDATE_WAITING_AREA_OPERATING_HOURS_FORM,
  GET_WAITING_AREA_LOCAL_ACCESS_HOURS,
  GOT_WAITING_AREA_LOCAL_ACCESS_HOURS,
  UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_FORM,
  GET_WAITING_AREA_LOGO_PAUSE_IMAGE,
  GOT_WAITING_AREA_LOGO_PAUSE_IMAGE,
  UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE_FORM,
  UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE,
  UPDATED_WAITING_AREA_LOGO_PAUSE_IMAGE,
  UPDATE_INITIATED_CN_WAITING_AREA_SEARCH,
  UPDATE_INPROGRESS_CN_WAITING_AREA_SEARCH,

  /////////////////////////////NOTIFy ROOM PARTICIPANTS////////////////////////////////////////////////////////////////////////////////
  UPDATE_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS_FORM,
  ///////////////////////////END NOTIFy ROOM PARTICIPANTS////////////////////////////////////////////////////////////////////////////////

  //GC waiting area settings
  GOT_GC_WAITING_AREA_SETTINGS,
  MODIFIED_GC_WA_SETTING_FORM,

  // Before calls
  GOT_WAITING_AREA_BEFORE_CALLS,
  MODIFIED_BEFORE_CALLS_FORM,

  // Before calls (Important Info)
  GOT_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO,
  MODIFIED_BEFORE_CALLS_IMPORTANT_INFO_FORM,

  // caller entry Point
  UPDATE_CALLER_ENTRY_POINT_FORM,
  MODIFIED_CALLER_ENTRY_POINT_FORM,
  CALLER_ENTRY_POINT_URL_IN_USE,

  // During calls
  UPDATE_DURING_CALLS_FORM,
  MODIFIED_DURING_CALLS_FORM,
  UPDATE_IS_RECORDING_AVAILABLE_ON_PORTAL,
  SET_CALL_QUALITY_PROFILE,

  // After calls
  GOT_WAITING_AREA_AFTER_CALLS,
  MODIFIED_AFTER_CALLS_FORM,

  // Share link to WA message
  GOT_WAITING_AREA_SHARE_LINK_MESSAGE,

  // Call history
  UPDATE_WA_CALL_HISTORY,

  //Manage roles for waiting areas
  GOT_AVAILABLE_ROLES_FOR_WAITING_AREA,
  UPDATE_SELECTED_USER_FOR_MANAGEMENT,
  UPDATE_ROLES_FOR_SELECTED_USER_IN_MANAGE_USERS_PAGE,
  //SELF PROVISION
  SET_WA_SELF_PROVISION_FORM,
  SET_WA_SELF_PROVISION_FORM_TRIM,
  RESET_WA_SELF_PROVISION_FORM,
  //CREATE WA
  SET_CREATE_WA_FORM,
  SET_CREATE_WA_FORM_TRIM,
  RESET_CREATE_WA_FORM,
  // Add WA users modal form
  ADD_USERS_FORM,
  // Support contact
  SUPPORT_CONTACT,
  // Information for Callers
  GOT_WAITING_AREA_INFORMATION_FOR_CALLERS,
  CHANGE_WAITING_AREA_INFORMATION_FOR_CALLERS,
  WAITING_AREA_INFORMATION_FILE_SIZE_EXCEED,
  WAITING_AREA_TAGS,
  // Advanced Menu
  SHOW_ADVANCED_MENU,
  // Select participant in PIWA
  UPDATE_SELECTED_PARTICIPANT_FORM_IN_WA,
  UPDATE_SELECTED_VIDEO_CALL_ROOM,
  UPDATE_SELECTED_VIDEO_CALL_ROOM_ID,

  // Lazy load waiting areas
  UPDATE_WA_IS_OPEN_OR_CLOSED,
  WAITING_AREAS_NEED_TO_UPDATE,

  // Auth ticket
  SET_AUTH_TICKET,
  // Add room details
  SET_WAITING_AREA_ROOM_AND_PARTICIPANTS,
  SET_WAITING_AREA_ROOM_AND_PARTICIPANTS_GC,
  SET_CALL_SUMMARY_BY_ID,
  REMOVE_WAITING_AREA_FROM_REDUCER,
  // Set email/sms template
  SET_WA_URL_EMAIL_TEMPLATE,
  SET_WA_URL_TEXT_TEMPLATE,
  // Consult now
  GOT_CONSULT_NOW_INITIATED_CALLS,
  UPDATE_SELECTED_CONSULT_NOW_CALLER,
  SET_VIDYO_ROOM_ID_FOR_CONSULT_NOW,
  SET_CONSULT_NOW_AUTH_TICKET,
  GOT_WARECORDING_SETTING_FEATURE,
} from 'actions/waitingArea.js';

import { sortManageRoleNaming } from 'businessLogic/sorting';
import { CONSULT_NOW_TOGGLE } from '../actions/shared';
import { NetworkTypes } from '../constants/networkTypes.js';

const reducer = (state = waitingAreaInitialState, action, cleanWaitingArea = state.cleanWaitingArea) => {
  switch (action.type) {
    case WAITING_AREAS_NEED_TO_UPDATE:
      return objectAssign({}, state, {
        waitingAreasInitiallyLoaded: action.data,
      });
    case UPDATE_MICROPHONE_SETTINGS_FOR_PROVIDER:
      var copy = clone(state);
      var foundWaitingArea = copy.waitingAreas.find((x) => x.id == copy.selectedWaitingAreaId);
      if (foundWaitingArea.providerCallConfig.isMicrophoneOn != action.data.isMicrophoneOn)
        foundWaitingArea.providerCallConfig.updatingMicrophoneSettingsForProvider = true;
      return copy;
    case UPDATED_MICROPHONE_SETTINGS_FOR_PROVIDER:
      var copy = clone(state);
      var foundWaitingArea = copy.waitingAreas.find((x) => x.id == copy.selectedWaitingAreaId);
      foundWaitingArea.providerCallConfig.updatingMicrophoneSettingsForProvider = false;
      foundWaitingArea.providerCallConfig.isMicrophoneOn = !!action.data.isMicrophoneOn; //the !! is to convert undefined into false
      return copy;
    case UPDATE_VIDEO_SETTINGS_FOR_PROVIDER:
      var copy = clone(state);
      var foundWaitingArea = copy.waitingAreas.find((x) => x.id == copy.selectedWaitingAreaId);
      if (foundWaitingArea.providerCallConfig.isCameraOn != action.data.isCameraOn)
        foundWaitingArea.providerCallConfig.updatingVideoSettingsForProvider = true;
      return copy;
    case UPDATED_VIDEO_SETTINGS_FOR_PROVIDER:
      var copy = clone(state);
      var foundWaitingArea = copy.waitingAreas.find((x) => x.id == copy.selectedWaitingAreaId);
      foundWaitingArea.providerCallConfig.updatingVideoSettingsForProvider = false;
      foundWaitingArea.providerCallConfig.isCameraOn = !!action.data.isCameraOn; //the !! is to convert undefined into false
      return copy;
    case ADD_TO_CALL_WAITING_AREA_PARTICIPANT:
      return objectAssign({}, state, { addingUserToWaitingArea: true });
    case ADDED_TO_CALL_WAITING_AREA_PARTICIPANT:
      return objectAssign({}, state, { addingUserToWaitingArea: false });
    case FAILED_ADDING_TO_CALL_WAITING_AREA_PARTICIPANT:
      return objectAssign({}, state, { addingUserToWaitingArea: false });
    case CALLER_DISCONNECTED: {
      var copy = clone(state);
      let roomWithParticipant = null;
      let indexOfParticipant = -1;
      let indexOfRoomWithParticipant = -1;
      let waitingArea = copy.waitingAreas.find((wa) => wa.id === copy.selectedWaitingAreaId);
      waitingArea.rooms.map((o, i) => {
        indexOfParticipant = o.participants.findIndex((oo) => oo.id == action.data);
        if (indexOfParticipant > -1) {
          roomWithParticipant = o;
          indexOfRoomWithParticipant = i;
          return;
        }
      });
      if (roomWithParticipant) {
        if (roomWithParticipant.participants[indexOfParticipant].isPrimaryCaller) {
          //if this person was disconnected, the room will disapear completely, so lets do this on client side;
          waitingArea.rooms.splice(indexOfRoomWithParticipant, 1);
        } else {
          roomWithParticipant.participants.splice(indexOfParticipant, 1);
        }
      }
      /// update one wa in wa array
      let i = copy.waitingAreas.findIndex((wa) => wa.id === copy.selectedWaitingAreaId);
      if (i > -1) {
        copy.waitingAreas[i] = Object.assign({}, copy.waitingAreas[i], waitingArea);
      }

      return objectAssign({}, state, { waitingAreas: copy.waitingAreas });
    }
    case UPDATE_WAITING_AREAS_SEARCH:
      return objectAssign({}, state, {
        currentWaitingAreasFilter: action.data,
      });

    case UPDATE_INITIATED_CN_WAITING_AREA_SEARCH:
      return objectAssign({}, state, {
        consultNowInitiatedWaitingAreasFilter: action.data,
      });

    case UPDATE_INPROGRESS_CN_WAITING_AREA_SEARCH:
      return objectAssign({}, state, {
        consultNowInporgressWaitingAreasFilter: action.data,
      });

    case UPDATE_WAITING_AREA_SMS_NOTIFICATION_FORM:
      return objectAssign({}, state, {
        waitingAreaSmsNotificationForm: action.data,
      });
    //Notify Room Participants
    case UPDATE_WAITING_AREA_NOTIFY_ROOM_PARTICIPANTS_FORM:
      return objectAssign({}, state, {
        notifyRoomParticipantsForm: action.data,
      });
    //End Notify Room Participants
    case UPDATE_WAITING_AREA_SMS_NOTIFICATION:
      var copy = clone(state.waitingAreaSmsNotificationForm);
      copy.updating = true;
      return objectAssign({}, state, { waitingAreaSmsNotificationForm: copy });
    case UPDATED_WAITING_AREA_SMS_NOTIFICATION:
      var copy = clone(state);
      var i = copy.waitingAreas.findIndex((wa) => wa.id === copy.selectedWaitingAreaId);
      if (i > -1) {
        copy.waitingAreas[i] = Object.assign({}, copy.waitingAreas[i], {
          myProviderStatus: {
            monitorContactNumber: action.data.mobilePhoneNumber,
            secondsBeforeSendingSms: action.data.secondsIntervalToSmsSendNotification,
          },
        });
      } else {
        console.error('waiting area not found');
      }
      console.log('updated');
      copy.waitingAreaSmsNotificationForm.updating = false;
      return objectAssign({}, state, copy);
    case ERROR_UPDATING_WAITING_AREA_SMS_NOTIFICATION:
      var copy = clone(state.waitingAreaSmsNotificationForm);
      copy.updating = false;
      return objectAssign({}, state, { waitingAreaSmsNotificationForm: copy });
    case UPDATE_WAITING_AREA_SEARCH:
      return objectAssign({}, state, { currentWaitingAreaFilter: action.data });
    case UPDATE_WAITING_AREA_MEMBER_SEARCH:
      return objectAssign({}, state, {
        currentWaitingAreaMemberFilter: action.data,
      });
    case RESET_WAITING_AREA_FORM:
      return objectAssign({}, state, { waitingAreaForm: cleanWaitingArea });
    case RESET_WAITING_AREA_SMS_NOTIFICATION_FORM:
      return objectAssign({}, state, {
        waitingAreaSmsNotificationForm: waitingAreaInitialState.cleanWaitingAreaSmsNotificationForm,
      });
    case UPDATED_CURRENT_FILLED_WAITING_AREA_STEP:
      return objectAssign({}, state, {
        currentFilledCreateWaitingAreaStep: action.data,
      });
    case UPDATED_CURRENT_CREATE_WAITING_AREA_STEP:
      return objectAssign({}, state, {
        currentCreateWaitingAreaStep: action.data,
      });
    case GOT_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS:
      let canCreateWaitingAreas = false;
      canCreateWaitingAreas = action.data.length > 0;
      return objectAssign({}, state, {
        fetchingOrganisationsWereIcanCreateWaitingAreas: false,
        organisationsWereIcanCreateWaitingAreas: action.data.push('Done'),
        canCreateWaitingAreas: canCreateWaitingAreas,
      });
    case GET_ORGANISATIONS_WERE_I_CAN_CREATE_WAITING_AREAS:
      return objectAssign({}, state, {
        fetchingOrganisationsWereIcanCreateWaitingAreas: true,
      });
    case UPDATED_WAITING_AREA_FORM:
      return objectAssign({}, state, { waitingAreaForm: action.data });

    case GET_WAITING_AREAS:
      return objectAssign({}, state, { fetchingWaitingAreas: true });

    case GET_ORGANISATION_WAITING_AREAS:
      return objectAssign({}, state, { fetchingWaitingAreas: true });

    case GOT_ORGANISATION_WAITING_AREAS:
      return objectAssign({}, state, {
        fetchingWaitingAreas: false,
        organisationWaitingAreas: action.data,
      });
    case UPDATE_WAITING_AREAS: {
      let userProfile = action.data;
      let copy = clone(state);
      let updatedWaitingAreas = copy.waitingAreas;
      if (
        userProfile &&
        userProfile.hasEntityAdminRights &&
        userProfile.hasEntityAdminRights.isOrgAdmin &&
        userProfile.shouldLoadDirectlyAssociatedWAs
      ) {
        let waitingAreaDA = userProfile.waitingAreasDirectlyAssociated.map((wa) => wa.id);
        updatedWaitingAreas = copy.waitingAreas.filter((wa) => waitingAreaDA.indexOf(wa.id) > -1);
      }
      return objectAssign({}, state, {
        waitingAreas: updatedWaitingAreas,
      });
    }

    case GOT_WAITING_AREAS:
      // TODO - Combine following 4 loops into a single one to improve performance
      action.data.forEach((wa) => calcWaitingStartForWaitingArea(wa, true));
      action.data.forEach((wa, i) => {
        if (wa.rooms) {
          wa.rooms.map((o, i) => {
            //here we create the syntatic property : status
            setMainParticipant(o);

            if (o.history && o.history.length > 0) {
              o.history.map((historyEvent, index) => {
                if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryTransferedCode) {
                  historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryTransfered;
                } else if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryJoinedCallCode) {
                  historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryJoinedCall;
                } else if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryLeftCallCode) {
                  historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryLeftCall;
                }
              });
            } else {
              o.history = [];
            }
          });
        }
      });

      // Keep existing data from redux state if new/replacement data is not avaiable this action data
      let copyActionData = [];
      let orginalData = [];
      const userProfile = action.userProfile;

      action.data.forEach((wa, i) => {
        let existingWaitingArea = state.waitingAreas.find((item) => item.id == wa.id);
        if (existingWaitingArea) wa = objectAssign({}, existingWaitingArea, wa);
        copyActionData.push(wa);
      });
      // do sorting
      sortWaitingAreas(copyActionData);

      return objectAssign({}, state, {
        fetchingWaitingAreas: false,
        waitingAreasInitiallyLoaded: true,
        waitingAreas: copyActionData,
      });

    case SELECT_WAITING_AREA:
      return objectAssign({}, state, {
        fetchingWaitingArea: true,
        selectedWaitingAreaId: action.data,
      });

    case SELECT_WAITING_AREA_ENTITY:
      return objectAssign({}, state, {
        selectedWaitingArea: action.data,
      });

    case RESET_WAITING_AREA:
      return objectAssign({}, state, { waitingArea: cleanWaitingArea });

    case SUSPEND_ACCESS_WAITING_AREA: {
      let waitingAreas = clone(state.waitingAreas);
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((item) => item.id == action.data);
        if (foundWaitingArea) foundWaitingArea.isSuspended = true;
      }
      return objectAssign({}, state, { waitingAreas: waitingAreas });
    }

    case UPDATED_SHOW_SUSPEND_WA_MODAL:
      return objectAssign({}, state, { showSuspendWAModal: action.data });

    case RESTORE_ACCESS_WAITING_AREA: {
      let waitingAreas = clone(state.waitingAreas);
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((item) => item.id == action.data);
        if (foundWaitingArea) foundWaitingArea.isSuspended = false;
      }
      return objectAssign({}, state, { waitingAreas });
    }
    //////////////////////////////////////////////Waiting Area Operating Hours////////////////////////////
    case GET_WAITING_AREA_OPERATING_HOURS:
      return objectAssign({}, state, { waitingAreaOperatingHoursForm: {} });

    case GOT_WAITING_AREA_OPERATING_HOURS:
      return objectAssign({}, state, {
        waitingAreaOperatingHoursForm: action.data,
      });

    case UPDATE_WAITING_AREA_OPERATING_HOURS_FORM:
      return objectAssign({}, state, {
        waitingAreaOperatingHoursForm: action.data,
      });
    /////////////////////////////////////////////End Waiting Area Operating Hours///////////////////////

    //////////////////////////////////////////////Waiting Area GC Setting////////////////////////////
    case GOT_GC_WAITING_AREA_SETTINGS:
      return objectAssign({}, state, {
        gcWaitingAreaSettings: action.data,
      });
    case MODIFIED_GC_WA_SETTING_FORM:
      return objectAssign({}, state, { gcWaitngAreaSettingForm: action.data });

    /////////////////////////////////////////////End Waiting Area GC Setting///////////////////////

    //////////////////////////////////////////////Waiting Area Local Access Hours////////////////////////////
    case GET_WAITING_AREA_LOCAL_ACCESS_HOURS:
      return objectAssign({}, state, { waitingAreaLocalAccessHoursForm: {} });

    case GOT_WAITING_AREA_LOCAL_ACCESS_HOURS:
      return objectAssign({}, state, {
        waitingAreaLocalAccessHoursForm: action.data,
      });

    case UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_FORM:
      return objectAssign({}, state, {
        waitingAreaLocalAccessHoursForm: action.data,
      });
    /////////////////////////////////////////////End Waiting Area Local Access Hours///////////////////////

    //////////////////////////////////////////////Waiting Area Local Access Hours////////////////////////////
    case GET_WAITING_AREA_LOCAL_ACCESS_HOURS:
      return objectAssign({}, state, { waitingAreaLocalAccessHoursForm: {} });

    case GOT_WAITING_AREA_LOCAL_ACCESS_HOURS:
      return objectAssign({}, state, {
        waitingAreaLocalAccessHoursForm: action.data,
      });

    case UPDATE_WAITING_AREA_LOCAL_ACCESS_HOURS_FORM:
      return objectAssign({}, state, {
        waitingAreaLocalAccessHoursForm: action.data,
      });
    /////////////////////////////////////////////End Waiting Area Local Access Hours///////////////////////

    ///////////////////////////////////////Create  WA, ORG and user (if needed)////////////

    ///////////////////////////////////////END Create  WA, ORG and user (if needed)////////////

    //////////////////////////////////////////////Logo Pause Image////////////////////////////
    case GET_WAITING_AREA_LOGO_PAUSE_IMAGE:
      return objectAssign({}, state, { waitingAreaLogoPauseImageForm: {} });

    case GOT_WAITING_AREA_LOGO_PAUSE_IMAGE:
      return objectAssign({}, state, {
        waitingAreaLogoPauseImageForm: action.data,
      });

    case UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE_FORM:
      return objectAssign({}, state, {
        waitingAreaLogoPauseImageForm: action.data,
      });

    case UPDATE_WAITING_AREA_LOGO_PAUSE_IMAGE:
      let waLogoPauseImageForm = clone(state.waitingAreaLogoPauseImageForm);
      waLogoPauseImageForm.isSaving = true;
      return objectAssign({}, state, {
        waitingAreaLogoPauseImageForm: waLogoPauseImageForm,
      });

    case UPDATED_WAITING_AREA_LOGO_PAUSE_IMAGE:
      let waLogoPauseUpdated = clone(state.waitingAreaLogoPauseImageForm);
      waLogoPauseUpdated.isSaving = false;
      return objectAssign({}, state, {
        waitingAreaLogoPauseImageForm: waLogoPauseUpdated,
      });

    // Call history
    case UPDATE_WA_CALL_HISTORY: {
      if (action.data.info) {
        return objectAssign({}, state, {
          waitingAreaCallHistory: action.data.info,
        });
      }
      return state;
    }

    /////////////////////////////////////////////End Logo Pause Image///////////////////////
    case UPDATE_WAITING_AREAS_PERMISSION: {
      let waitingAreas = clone(state.waitingAreas);

      action.data.map((x) => {
        let wa = waitingAreas.find((wa) => wa.id == x.id);
        if (wa) {
          wa.permissions = x.permissions;
        }
      });
      return objectAssign({}, state, { waitingAreas });
    }

    case UPDATED_WAITING_AREA: {
      let waitingAreas = clone(state.waitingAreas);
      if (waitingAreas.length > 0) {
        let currentWA = waitingAreas.find((item) => item.id == action.data.id);
        if (!!currentWA) {
          currentWA.name = action.data.name;
          currentWA.shortDescription = action.data.shortDescription;
        }
        return objectAssign({}, state, { waitingAreas });
      } else {
        return state;
      }
    }
    case GET_WAITING_AREA_WEBSITE_DETAILS:
      return objectAssign({}, state, { waitingAreaWebsiteButton: {} });

    case GOT_WAITING_AREA_WEBSITE_DETAILS:
      return objectAssign({}, state, { waitingAreaWebsiteButton: action.data });

    // Caller entry point
    case UPDATE_CALLER_ENTRY_POINT_FORM:
      var callerEntryPointSettings = {
        isWaitingAreaPublic: action.data.isWaitingAreaPublic,
        shortUrl: action.data.attendAnywhereShortUrl || '',
        customUrl: action.data.customUrl || action.data.orgCustomWebsiteUrl || '',
        maxUrlLength: action.data.maxUrlLength || 65,
        longUrl: action.data.longUrl,
      };
      return objectAssign({}, state, {
        callerEntryPointForm: callerEntryPointSettings,
      });

    case MODIFIED_CALLER_ENTRY_POINT_FORM:
      var callerEntryPointForm = objectAssign({}, action.data, {
        urlExtenstionIsInUse: false,
      });
      return objectAssign({}, state, {
        callerEntryPointForm: callerEntryPointForm,
      });
    case CALLER_ENTRY_POINT_URL_IN_USE:
      var callerEntryPointForm = objectAssign({}, state.callerEntryPointForm, {
        urlExtenstionIsInUse: action.data,
      });
      return objectAssign({}, state, {
        callerEntryPointForm: callerEntryPointForm,
      });

    // During calls
    case UPDATE_DURING_CALLS_FORM:
      var waitingAreas = clone(state.waitingAreas);
      var duringCallsSetting = {
        callQuality: action.data.callQuality,
        displayMessageMinutes: action.data.displayMessageMinutes,
        displayMessageSeconds: action.data.displayMessageSeconds,
        message: action.data.message || '',
        moreAssistance: action.data.moreAssistance,
        isRecordingEnabled: action.data.isRecordingEnabled === null ? false : action.data.isRecordingEnabled,
        isOrganisationRecordingEnabled: action.data.isOrganisationRecordingEnabled,
        showCallerQueuePosition: action.data.showCallerQueuePosition,
        enableCalculateQueuePosition: action.data.enableCallerQueuePosition,
        showWaitingAreaBulletin: action.data.showWaitingAreaBulletin,
      };
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((x) => x.id == state.selectedWaitingAreaId);
        if (foundWaitingArea) foundWaitingArea.duringCallsSettings = duringCallsSetting;
      }
      return objectAssign({}, state, {
        waitingAreas: waitingAreas,
        duringCallsForm: duringCallsSetting,
      });

    case MODIFIED_DURING_CALLS_FORM:
      return objectAssign({}, state, { duringCallsForm: action.data });

    case UPDATE_IS_RECORDING_AVAILABLE_ON_PORTAL:
      return objectAssign({}, state, {
        isRecordingAvailableOnPortal: action.data,
      });

    case SET_CALL_QUALITY_PROFILE:
      if (action.data) {
        let callQualityOptionsArray = [];
        var entry;
        for (entry in action.data.videoCallQualityProfiles) {
          let pushEntry = {
            value: action.data.videoCallQualityProfiles[entry].id.toString(),
            text: action.data.videoCallQualityProfiles[entry].description,
          };
          callQualityOptionsArray.push(pushEntry);
        }
        return objectAssign({}, state, {
          callQualityOptions: callQualityOptionsArray,
        });
      }
      return objectAssign({}, state, { callQualityOptions: [] });

    case UPDATE_WEBSITE_BUTTON_DETAILS:
      var copy = clone(state);
      copy.waitingAreaWebsiteButton.fetchingWebSiteButtonDetails = true;
      return objectAssign({}, state, {
        waitingAreaWebsiteButton: copy.waitingAreaWebsiteButton,
      });

    case UPDATED_WEBSITE_BUTTON_DETAILS:
      var copy = clone(state);
      copy.waitingAreaWebsiteButton.fetchingWebSiteButtonDetails = false;
      return objectAssign({}, state, {
        waitingAreaWebsiteButton: copy.waitingAreaWebsiteButton,
      });

    case UPDATED_WEBSITE_BUTTON_FORM:
      return objectAssign({}, state, { waitingAreaWebsiteButton: action.data });

    // Before calls
    case GOT_WAITING_AREA_BEFORE_CALLS:
      var waitingAreas = clone(state.waitingAreas);
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((x) => x.id == state.selectedWaitingAreaId);
        if (foundWaitingArea) foundWaitingArea.beforeCallsSettings = action.data;
      }
      return objectAssign({}, state, {
        waitingAreas: waitingAreas,
        beforeCallsForm: action.data,
      });

    case MODIFIED_BEFORE_CALLS_FORM:
      return objectAssign({}, state, { beforeCallsForm: action.data });

    // Before calls (Important Info)
    case GOT_WAITING_AREA_BEFORE_CALLS_IMPORTANT_INFO: {
      var waitingAreas = clone(state.waitingAreas);
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((x) => x.id == state.selectedWaitingAreaId);
        if (foundWaitingArea) foundWaitingArea.beforeCallsImportantInfo = action.data;
      }

      let beforeCallsImportantInfoForm = {
        importantInfo: {
          value: action.data.htmlContent,
          maxLineLength: action.data.maxLineLength || 10,
          maxCharLength: action.data.maxCharLength || 500,
          ifTextEmpty: false,
          showCharLimitWarning: false,
        },
      };
      return objectAssign({}, state, {
        waitingAreas: waitingAreas,
        beforeCallsImportantInfoForm: beforeCallsImportantInfoForm,
      });
    }
    case MODIFIED_BEFORE_CALLS_IMPORTANT_INFO_FORM:
      var beforeCallsImportantInfoForm = clone(state.beforeCallsImportantInfoForm);
      beforeCallsImportantInfoForm.importantInfo.value = action.data.value;
      beforeCallsImportantInfoForm.importantInfo.ifTextEmpty = action.data.ifTextEmpty;
      beforeCallsImportantInfoForm.importantInfo.showCharLimitWarning = action.data.showCharLimitWarning || false;
      return objectAssign({}, state, {
        beforeCallsImportantInfoForm: beforeCallsImportantInfoForm,
      });

    // After calls
    case GOT_WAITING_AREA_AFTER_CALLS:
      var waitingAreas = clone(state.waitingAreas);
      var afterCallsSettings = {
        callProviderUrl: action.data.callProviderUrl == null ? '' : action.data.callProviderUrl,
        callerGuestUrl: action.data.callerGuestUrl == null ? '' : action.data.callerGuestUrl,
        postCallOption: action.data.postCallOption,
        postCallUrl: action.data.postCallUrl == null ? '' : action.data.postCallUrl,
      };
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((x) => x.id == state.selectedWaitingAreaId);
        if (foundWaitingArea) foundWaitingArea.afterCallsSettings = afterCallsSettings;
      }
      return objectAssign({}, state, {
        waitingAreas: waitingAreas,
        afterCallsForm: afterCallsSettings,
      });
    case MODIFIED_AFTER_CALLS_FORM:
      return objectAssign({}, state, { afterCallsForm: action.data });

    // Manage Support Contact
    case SUPPORT_CONTACT.GOT_INFO:
      var waitingAreas = clone(state.waitingAreas);
      var supportContactForm = {
        supportName: action.data.supportName || '',
        supportEmail: action.data.supportEmail || '',
        supportPhone: action.data.supportPhone || '',
        supportWebsite: action.data.supportWebsite || '',
        moreAssistance: action.data.moreAssistance || '',
        organisaionSupportName: action.data.organisaionSupportName || '',
        organisaionSupportEmail: action.data.organisaionSupportEmail || '',
        organisaionSupportPhone: action.data.organisaionSupportPhone || '',
        organisaionSupportWebsite: action.data.organisaionSupportWebsite || '',
      };
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((x) => x.id == state.selectedWaitingAreaId);
        if (foundWaitingArea) foundWaitingArea.supportContactForm = supportContactForm;
      }
      return objectAssign({}, state, {
        supportContactForm: supportContactForm,
      });
    case SUPPORT_CONTACT.CHANGE_SUPPORT_CONTACT_INFO:
      return objectAssign({}, state, { supportContactForm: action.data });
    case SUPPORT_CONTACT.RESET_SUPPORT_CONTACT:
      return objectAssign({}, state, {
        supportContactForm: supportContactForm,
      });
    // Share link to WA message
    case GOT_WAITING_AREA_SHARE_LINK_MESSAGE: {
      let waitingAreas = clone(state.waitingAreas);
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((x) => x.id == state.selectedWaitingAreaId);
        if (foundWaitingArea) foundWaitingArea.shareLinkMessageSettings = action.data;
      }
      return objectAssign({}, state, {
        waitingAreas: waitingAreas,
        shareLinkMessageForm: action.data,
      });
    }
    //Information for Callers
    case GOT_WAITING_AREA_INFORMATION_FOR_CALLERS:
      var waitingAreas = clone(state.waitingAreas);
      var informationForCallersForm = {
        moreAssistance: action.data.moreAssistance || '',
        fileName: action.data.fileName,
        isDefaultFile: action.data.isDefaultFile,
        uploadFileNotAccepted: false,
        includeCallerLink: action.data.includeCallerLink,
        callerLink: action.data.callerLink,
      };
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((x) => x.id == state.selectedWaitingAreaId);
        if (foundWaitingArea) foundWaitingArea.informationForCallersForm = informationForCallersForm;
      }
      return objectAssign({}, state, {
        waitingAreas: waitingAreas,
        informationForCallersForm: informationForCallersForm,
      });

    case CHANGE_WAITING_AREA_INFORMATION_FOR_CALLERS:
      return objectAssign({}, state, {
        informationForCallersForm: action.data,
      });
    case WAITING_AREA_INFORMATION_FILE_SIZE_EXCEED:
      var informationForCallersForm = clone(state.informationForCallersForm);
      informationForCallersForm.uploadFileNotAccepted = action.data;
      return objectAssign({}, state, {
        informationForCallersForm: informationForCallersForm,
      });
    // Manage available roles for waiting area
    case GOT_AVAILABLE_ROLES_FOR_WAITING_AREA:
      var waitingAreas = clone(state.waitingAreas);
      let availableRoles = sortManageRoleNaming(action.data);
      if (waitingAreas.length > 0) {
        let foundWaitingArea = waitingAreas.find((selectedWA) => selectedWA.id == state.selectedWaitingAreaId);
        if (foundWaitingArea) foundWaitingArea.availableRoles = availableRoles;
      }
      return objectAssign({}, state, { waitingAreas: waitingAreas });

    // Manage user for users lists
    case UPDATE_SELECTED_USER_FOR_MANAGEMENT:
      var manageUsersPage = {
        selectedUserId: action.data,
      };
      return Object.assign({}, state, {
        manageUsersPage: manageUsersPage,
      });
    case UPDATE_ROLES_FOR_SELECTED_USER_IN_MANAGE_USERS_PAGE:
      var manageUsersPage = clone(state.manageUsersPage);
      manageUsersPage.rolesForSelectedUser = action.data;
      return Object.assign({}, state, {
        manageUsersPage: manageUsersPage,
      });

    // Advanced menu
    case SHOW_ADVANCED_MENU:
      return Object.assign({}, state, { showAdvancedMenu: action.data });

    case GOT_WAITING_AREA:
      let copyWaitingAreas = setCallersForWaitingArea(action.data, state);

      return objectAssign({}, state, {
        fetchingWaitingArea: false,
        waitingAreas: copyWaitingAreas,
      });

    case GOT_WAITING_AREA_GC:
      let waitingAreaGCNew = setRoomsForGCWaitingArea(action.data);
      let copyWaitingAreasGC = setCallersForWaitingArea(waitingAreaGCNew, state);

      return objectAssign({}, state, {
        fetchingWaitingArea: false,
        waitingAreas: copyWaitingAreasGC,
      });

    case UPDATE_FETCHING_WAITING_AREA:
      return objectAssign({}, state, {
        fetchingWaitingArea: action.data,
      });
    case ADD_USERS_FORM.SELECT_ROLE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, {
        selectedRoles: state.addUsersForm.selectedRoles.concat(action.data),
      });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case ADD_USERS_FORM.UNSELECT_ROLE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, {
        selectedRoles: state.addUsersForm.selectedRoles.filter((item) => item != action.data),
      });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case ADD_USERS_FORM.UPDATE_MESSAGE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, {
        message: action.data,
      });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case ADD_USERS_FORM.CLEAR_FORM: {
      // reset the form state
      return objectAssign({}, state, {
        addUsersForm: waitingAreaInitialState.addUsersForm,
      });
    }
    case ADD_USERS_FORM.ADDING_USERS_TO_WAITING_AREA: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm);
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    //--------------------- REGISTER Self Provision  WA AND ORG ----------------------------------
    case SET_WA_SELF_PROVISION_FORM:
      return objectAssign({}, state, { selfProvisionCreateForm: action.data });
    case SET_WA_SELF_PROVISION_FORM_TRIM:
      let selfProvisionTrim = clone(state.selfProvisionCreateForm);
      selfProvisionTrim.firstName = selfProvisionTrim.firstName ? selfProvisionTrim.firstName.trim() : '';
      selfProvisionTrim.lastName = selfProvisionTrim.lastName ? selfProvisionTrim.lastName.trim() : '';
      selfProvisionTrim.organisationName = selfProvisionTrim.organisationName
        ? selfProvisionTrim.organisationName.trim()
        : '';
      selfProvisionTrim.organisationAbbreviation = selfProvisionTrim.organisationAbbreviation
        ? selfProvisionTrim.organisationAbbreviation.trim()
        : '';
      selfProvisionTrim.waitingAreaName = selfProvisionTrim.waitingAreaName
        ? selfProvisionTrim.waitingAreaName.trim()
        : '';
      selfProvisionTrim.waitingAreaUrl = selfProvisionTrim.waitingAreaUrl
        ? selfProvisionTrim.waitingAreaUrl.trim()
        : '';

      return objectAssign({}, state, {
        selfProvisionCreateForm: selfProvisionTrim,
      });

    case RESET_WA_SELF_PROVISION_FORM:
      return objectAssign({}, state, { selfProvisionCreateForm: {} });

    //---------------------END REGISTER USER WITH WA AND ORG---------------------------------------------

    //--------------------------------CREATE WA via org dialog
    case SET_CREATE_WA_FORM:
      return objectAssign({}, state, { createWAForm: action.data });
    case SET_CREATE_WA_FORM_TRIM:
      let createWATrim = clone(state.createWAForm);
      createWATrim.waitingAreaName = createWATrim.waitingAreaName ? createWATrim.waitingAreaName.trim() : '';
      createWATrim.waitingAreaUrl = createWATrim.waitingAreaUrl ? createWATrim.waitingAreaUrl.trim() : '';

      return objectAssign({}, state, { createWAForm: createWATrim });

    case RESET_CREATE_WA_FORM:
      return objectAssign({}, state, { createWAForm: {} });
    //------------------------------------------END CREATE WA via org dialogue

    //--------------------- WAITING AREA TAGS ----------------------------------

    case WAITING_AREA_TAGS.GOT_TAGS:
      let copyWaitingAreasWithTags = clone(state.waitingAreas);
      let foundWaitingAreaWithTags = copyWaitingAreasWithTags.find((x) => x.id == action.data.waitingAreaId);
      if (foundWaitingAreaWithTags) foundWaitingAreaWithTags.tags = action.data.tags;
      return objectAssign({}, state, {
        waitingAreas: copyWaitingAreasWithTags,
      });
    case WAITING_AREA_TAGS.UPDATE_SEARCH_TERM:
      return objectAssign({}, state, {
        currentWaitingAreaTagFilter: action.data,
      });
    case WAITING_AREA_TAGS.GOT_AVAILABLE_TAGS_BY_NETWORKID:
      return objectAssign({}, state, {
        availableTagsByWaitingAreaId: action.data,
      });
    case WAITING_AREA_TAGS.UPDATE_SELECTED_TAG_FOR_MANAGEMENT:
      let selectedTagObject = clone(state).selectedTagObject;
      let updatedSelectedTagObject = objectAssign({}, selectedTagObject, action.data);
      return objectAssign({}, state, {
        selectedTagObject: updatedSelectedTagObject,
      });
    case WAITING_AREA_TAGS.UPDATE_ASSIGN_TAG_VALUES_FORM:
      let assignTagValuesForm = clone(state).assignTagValuesForm;
      let updatedAssignTagValuesForm = objectAssign({}, assignTagValuesForm, action.data);
      return objectAssign({}, state, {
        assignTagValuesForm: updatedAssignTagValuesForm,
      });
    case WAITING_AREA_TAGS.CLEAR_TEMP_ASSIGN_TAGS_OBJECT:
      return objectAssign({}, state, {
        selectedTagObject: waitingAreaInitialState.selectedTagObject,
        assignTagValuesForm: waitingAreaInitialState.assignTagValuesForm,
      });
    //--------------------- END WAITING AREA TAGS  -----------------------------

    //--------------------- PARTICIPANT WORKFLOW IN PIWA -----------------------
    case UPDATE_SELECTED_PARTICIPANT_FORM_IN_WA:
      return objectAssign({}, state, { selectedParticipantForm: action.data });
    case UPDATE_SELECTED_VIDEO_CALL_ROOM:
      return objectAssign({}, state, {
        selectedVideoCallRoomForm: action.data,
      });
    case UPDATE_SELECTED_VIDEO_CALL_ROOM_ID:
      return objectAssign({}, state, { selectedVideoCallRoomId: action.data });
    // Update WA is open or not
    case UPDATE_WA_IS_OPEN_OR_CLOSED:
      let copyWaitingAreasIsOpenOrNot = clone(state.waitingAreas);
      let foundWaitingAreaIsOpenOrNot = copyWaitingAreasIsOpenOrNot.find((x) => x.id == action.data.waitingAreaId);
      if (foundWaitingAreaIsOpenOrNot && foundWaitingAreaIsOpenOrNot.operatingHours)
        foundWaitingAreaIsOpenOrNot.operatingHours.isOpen = action.data.isOpen;

      if (action.data.nextClosedTime)
        foundWaitingAreaIsOpenOrNot.operatingHours.nextClosedTime = action.data.nextClosedTime;
      if (action.data.nextOpenTime) foundWaitingAreaIsOpenOrNot.operatingHours.nextOpenTime = action.data.nextOpenTime;
      return objectAssign({}, state, {
        waitingAreas: copyWaitingAreasIsOpenOrNot,
      });

    case SET_AUTH_TICKET: {
      let storedWaitingAreas = clone(state.waitingAreas);
      let foundIndex = storedWaitingAreas.findIndex((x) => x.id === action.data.waitingAreaId);
      if (foundIndex > -1) {
        let selectedWaitingArea = storedWaitingAreas[foundIndex];
        if (!!selectedWaitingArea.authTickets) {
          let authTicketArray = clone(selectedWaitingArea.authTickets);
          for (let i = 0; i < authTicketArray.length; i++) {
            if (authTicketArray[i].roomId === action.data.roomId) {
              authTicketArray[i] = {
                roomId: action.data.roomId,
                callScreenAuthTicket: action.data.authTicket,
              };
              break;
            }
            if (i === authTicketArray.length - 1) {
              authTicketArray.push({
                roomId: action.data.roomId,
                callScreenAuthTicket: action.data.authTicket,
              });
            }
          }
          selectedWaitingArea.authTickets = authTicketArray;
        } else {
          selectedWaitingArea.authTickets = [
            {
              roomId: action.data.roomId,
              callScreenAuthTicket: action.data.authTicket,
            },
          ];
        }
      }
      return objectAssign({}, state, { waitingAreas: storedWaitingAreas });
    }
    case SET_WAITING_AREA_ROOM_AND_PARTICIPANTS: {
      let storedWaitingAreas = setWARoomAndParticipants(action, state);
      return objectAssign({}, state, { waitingAreas: storedWaitingAreas });
    }
    case SET_WAITING_AREA_ROOM_AND_PARTICIPANTS_GC: {
      action.data.roomsDetail.rooms = setRoomsForGCWaitingArea(action.data.roomsDetail, state).rooms || [];
      let storedWaitingAreas = setWARoomAndParticipants(action, state);
      return objectAssign({}, state, { waitingAreas: storedWaitingAreas });
    }
    case SET_CALL_SUMMARY_BY_ID: {
      let storedWaitingAreas = clone(state.waitingAreas);
      let foundIndex = storedWaitingAreas.findIndex((x) => x.id === action.data.waitingAreaId);
      if (foundIndex > -1) {
        let selectedWaitingArea = clone(storedWaitingAreas[foundIndex]);
        let newWaitingArea = objectAssign({}, selectedWaitingArea, {
          callSummary: action.data.callSummary || {
            peopleWaiting: 0,
            peopleBeingAttended: 0,
            peopleIdle: 0,
            longestWait: 0,
          },
        });
        // calc begining time
        calcWaitingStartForWaitingArea(newWaitingArea, true);
        storedWaitingAreas[foundIndex] = newWaitingArea;
        sortWaitingAreas(storedWaitingAreas);
      }

      return objectAssign({}, state, { waitingAreas: storedWaitingAreas });
    }
    case REMOVE_WAITING_AREA_FROM_REDUCER: {
      let waitingAreas = clone(state.waitingAreas);
      let foundIndex = waitingAreas.findIndex((x) => x.id == action.data);
      if (foundIndex > -1) {
        // Found the existing wa
        waitingAreas.splice(foundIndex, 1);
      }
      return objectAssign({}, state, { waitingAreas: waitingAreas });
    }
    case SET_WA_URL_EMAIL_TEMPLATE: {
      return objectAssign({}, state, {
        waURLEmailData: {
          message: action.data.message || '',
          additionalMessage: action.data.additionalMessage || '',
          isEditAllowed: action.data.isEditAllowed,
        },
      });
    }
    case SET_WA_URL_TEXT_TEMPLATE: {
      return objectAssign({}, state, {
        waURLTextData: {
          message: action.data.message || '',
          additionalMessage: action.data.additionalMessage || '',
          isEditAllowed: action.data.isEditAllowed,
        },
      });
    }
    case GOT_CONSULT_NOW_INITIATED_CALLS: {
      let storedWaitingAreas = clone(state.waitingAreas);
      let foundIndex = storedWaitingAreas.findIndex((x) => x.id === action.data.waitingAreaId);
      if (foundIndex > -1) {
        let selectedWaitingArea = clone(storedWaitingAreas[foundIndex]);
        let newWaitingArea = objectAssign({}, selectedWaitingArea, {
          initatedCalls: action.data.initialedCalls,
        });
        storedWaitingAreas[foundIndex] = newWaitingArea;
      }
      return objectAssign({}, state, { waitingAreas: storedWaitingAreas });
    }
    case UPDATE_SELECTED_CONSULT_NOW_CALLER: {
      return objectAssign({}, state, { selectedConsultNowCaller: action.data });
    }
    case SET_VIDYO_ROOM_ID_FOR_CONSULT_NOW: {
      return objectAssign({}, state, { consultNowVidyoRoomId: action.isModalOpen ? action.data : null });
    }
    case SET_CONSULT_NOW_AUTH_TICKET: {
      return objectAssign({}, state, { consultNowAuthTicket: action.data });
    }
    case GOT_WARECORDING_SETTING_FEATURE: {
      return objectAssign({}, state, { WARecordingFeature: action.data });
    }
    default:
      return state;
  }
};

function calcWaitingStartForWaitingArea(wa, respectCallSummary = false) {
  if (respectCallSummary) {
    if (wa.callSummary.peopleWaiting === 0) {
      wa.callSummary.calculatedLongestWaitFrom = null;
    } else {
      wa.callSummary.calculatedLongestWaitFrom =
        wa.callSummary.longestWait === 0 ? new Date() - 0 : new Date() - (wa.callSummary.longestWait * 60000 + 30000); // tradoff for the trafic time
    }
  } else {
    wa.rooms.map((o) => {
      // calc begining time
      o.calculatedRoomWaitingFrom = new Date() - o.durationInCurrentStatusInSeconds;
    });

    var waitings = wa.rooms
      .filter((room) => room.statusId === APP.LANGUAGE.MessageCodes.StatusWaitingCode)
      .map((r) => r.calculatedRoomWaitingFrom);
    if (waitings.length > 0) {
      wa.callSummary.calculatedLongestWaitFrom = Math.min(...waitings);
    } else {
      wa.callSummary.calculatedLongestWaitFrom = null;
    }
  }
}

function setMainParticipant(room, waitingArea) {
  let mainParticipant = room.participants.find((x) => x.isPrimaryCaller == true);
  // If it is for group consultation then there won't be any primary caller so lets assume 1st caller to room is a primary caller
  if (!mainParticipant && waitingArea && waitingArea.networkTypeId === NetworkTypes.GroupConsultation) {
    mainParticipant = clone(room.participants[0]);
    // If room is INPROGRESS or IDLE then set room name as Group Consultation
    if (room.statusId != APP.LANGUAGE.MessageCodes.StatusWaitingCode) {
      mainParticipant.name = APP.LANGUAGE.EntityAdmin.GroupConsultation;
      room.name = APP.LANGUAGE.EntityAdmin.GroupConsultation;
    }
  }
  // Set status of the room
  if (room.statusId == APP.LANGUAGE.MessageCodes.StatusIdleCode)
    mainParticipant.status = APP.LANGUAGE.ViewOneWaitingArea.Idle;
  else if (room.statusId == APP.LANGUAGE.MessageCodes.StatusWaitingCode)
    mainParticipant.status = APP.LANGUAGE.ViewOneWaitingArea.Waiting;
  else if (room.statusId == APP.LANGUAGE.MessageCodes.StatusAttendedCode)
    mainParticipant.status = APP.LANGUAGE.ViewOneWaitingArea.Attended;

  room.mainParticipant = mainParticipant;
}

function sortWaitingAreas(waitingAreas) {
  waitingAreas.sort(compareWaitingArea);
}

export function compareWaitingArea(a, b) {
  if (a.callSummary.peopleIdle > b.callSummary.peopleIdle) {
    return -1;
  } else if (a.callSummary.peopleIdle < b.callSummary.peopleIdle) {
    return 1;
  }

  if (a.callSummary.peopleWaiting > b.callSummary.peopleWaiting) {
    return -1;
  } else if (a.callSummary.peopleWaiting < b.callSummary.peopleWaiting) {
    return 1;
  }

  if (a.callSummary.peopleBeingAttended > b.callSummary.peopleBeingAttended) {
    return -1;
  } else if (a.callSummary.peopleBeingAttended < b.callSummary.peopleBeingAttended) {
    return 1;
  }

  if (a.callSummary.calculatedLongestWaitFrom < b.callSummary.calculatedLongestWaitFrom) {
    return -1;
  } else if (a.callSummary.calculatedLongestWaitFrom > b.callSummary.calculatedLongestWaitFrom) {
    return 1;
  }

  // sort by whether the WA is suspended
  if (a.isSuspended === true && b.isSuspended !== true) {
    return -1;
  } else if (a.isSuspended !== true && b.isSuspended === true) {
    return 1;
  }

  // a.name is equal to b.name, then sort by org unit name
  if (a.name.localeCompare(b.name) === 0) {
    return a.organisationName.localeCompare(b.organisationName);
  }

  return a.name.localeCompare(b.name);
}

function setWARoomAndParticipants(action, state) {
  let storedWaitingAreas = clone(state.waitingAreas);
  let foundIndex = storedWaitingAreas.findIndex((x) => x.id === action.data.waitingAreaId);
  if (foundIndex > -1) {
    let selectedWaitingArea = clone(storedWaitingAreas[foundIndex]);
    let newWaitingArea = objectAssign({}, selectedWaitingArea, {
      rooms: action.data.roomsDetail.rooms || [],
      callSummary: action.data.roomsDetail.callSummary || {
        peopleWaiting: 0,
        peopleBeingAttended: 0,
        peopleIdle: 0,
        longestWait: 0,
      },
    });

    let differenceBetweenArrays = 0;
    if (newWaitingArea && newWaitingArea.rooms) {
      differenceBetweenArrays = newWaitingArea.rooms.filter(function (obj) {
        return !newWaitingArea.rooms.some(function (obj2) {
          return obj.id == obj2.id;
        });
      });
    }

    if (differenceBetweenArrays.length > 0 && newWaitingArea.rooms.length != 0) {
      newWaitingArea.newRooms = true;
    } else {
      newWaitingArea.newRooms = false;
    }

    newWaitingArea.rooms.map((o) => {
      //here we create the syntatic property : status
      setMainParticipant(o, newWaitingArea);

      if (o.history && o.history.length > 0) {
        o.history.map((historyEvent, index) => {
          if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryTransferedCode) {
            historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryTransfered;
          } else if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryJoinedCallCode) {
            historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryJoinedCall;
          } else if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryLeftCallCode) {
            historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryLeftCall;
          }
        });
      } else {
        o.history = [];
      }
    });
    // calc begining time
    calcWaitingStartForWaitingArea(newWaitingArea);
    storedWaitingAreas[foundIndex] = newWaitingArea;
    sortWaitingAreas(storedWaitingAreas);
  }

  return storedWaitingAreas;
}

function setCallersForWaitingArea(waitingAreaNew, state) {
  let waitingAreaFound = state.waitingAreas.find((wa) => wa.id === waitingAreaNew.id);
  let differenceBetweenArrays = 0;
  if (waitingAreaFound && waitingAreaFound.rooms) {
    differenceBetweenArrays = waitingAreaNew.rooms.filter(function (obj) {
      return !waitingAreaFound.rooms.some(function (obj2) {
        return obj.id == obj2.id;
      });
    });
  }

  if (differenceBetweenArrays.length > 0 && waitingAreaFound.rooms.length != 0) {
    waitingAreaNew.newRooms = true;
  } else {
    waitingAreaNew.newRooms = false;
  }

  waitingAreaNew.rooms.map((o) => {
    //here we create the syntatic property : status
    setMainParticipant(o, waitingAreaNew);

    if (o.history && o.history.length > 0) {
      o.history.map((historyEvent, index) => {
        if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryTransferedCode) {
          historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryTransfered;
        } else if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryJoinedCallCode) {
          historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryJoinedCall;
        } else if (historyEvent.eventCode == APP.LANGUAGE.MessageCodes.HistoryLeftCallCode) {
          historyEvent.synteticMessage = APP.LANGUAGE.ViewOneWaitingArea.HistoryLeftCall;
        }
      });
    } else {
      o.history = [];
    }
  });

  // calc begining time
  calcWaitingStartForWaitingArea(waitingAreaNew);

  waitingAreaNew.myProviderStatus.secondsBeforeSendingSms =
    waitingAreaNew.myProviderStatus.secondsBeforeSendingSms / 60;
  /// update only one wa in wa array
  let copyWaitingAreas = clone(state.waitingAreas);
  let index = copyWaitingAreas.findIndex((wa) => wa.id === waitingAreaNew.id);
  if (index > -1) {
    // waiting area already exist in state, update existing
    copyWaitingAreas[index] = Object.assign({}, copyWaitingAreas[index], waitingAreaNew);
  } else {
    // waiting area already exist in state, add new

    copyWaitingAreas.push(Object.assign({}, state.cleanWaitingArea, waitingAreaNew));
  }

  // sorting
  sortWaitingAreas(copyWaitingAreas);

  return copyWaitingAreas;
}

function setRoomsForGCWaitingArea(data) {
  if (!data.rooms || data.rooms.length === 0) {
    return data;
  }

  // We will be getting a single room with participants (all callers) with their statuses
  // Need to divide those into multiple rooms, If there are In Progress then it will be one room with all callers in progress
  // Then there will be a separate room for each caller Waiting (late comer)
  var participantsWaiting = data.rooms[0].participants.filter(function (obj) {
    return obj.callState.toLowerCase() === APP.LANGUAGE.ViewOneWaitingArea.Waiting.toLowerCase();
  });
  var rooms = [];
  var count = -1;
  // Set
  data.rooms[0].id = count;
  // Initializing rooms for each waiting caller
  var currentDate = Date.now();
  participantsWaiting.map((pr) => {
    var room = clone(data.rooms[0]);
    room.id = --count;
    room.participants = [pr];
    room.name = pr.name;
    room.statusId = APP.LANGUAGE.MessageCodes.StatusWaitingCode;
    room.isCurrentUserAnsweringThisCall = false;
    room.durationInCurrentStatusInSeconds = currentDate - new Date(pr.joinTime).valueOf();
    room.dob = pr.personDOB;
    rooms.push(room);
    // Remove Waiting participant from In Progress/Idle room as we have created separate rooms for them
    if (data.rooms[0].statusId != APP.LANGUAGE.MessageCodes.StatusWaitingCode) {
      data.rooms[0].participants.splice(data.rooms[0].participants.indexOf(pr), 1);
    }
  });

  if (data.rooms[0].statusId != APP.LANGUAGE.MessageCodes.StatusWaitingCode) {
    data.rooms = [...data.rooms, ...rooms];
  } else {
    data.rooms = rooms;
  }

  return data;
}

export default reducer;
